import { render, staticRenderFns } from "./drag-resize.vue?vue&type=template&id=e7e7b1fc&scoped=true&"
import script from "./drag-resize.vue?vue&type=script&lang=js&"
export * from "./drag-resize.vue?vue&type=script&lang=js&"
import style0 from "./drag-resize.vue?vue&type=style&index=0&id=e7e7b1fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e7b1fc",
  null
  
)

export default component.exports